import { EngineControllerService } from 'shared/api/generatedApi/services/EngineControllerService';
import { EngineRequestDto } from 'shared/api';

export const engineApi = {
  getEngines: (userId?: number, engineType?: EngineRequestDto.engineType) => EngineControllerService.findEngines(userId, engineType),
  getEngineById: (id: number) => EngineControllerService.findEngineById(id),
  createEngine: (data: EngineRequestDto) => EngineControllerService.createEngine(data),
  updateEngine: (id: number, data: EngineRequestDto) => EngineControllerService.updateEngine(id, data),
  deleteEngine: (id: number) => EngineControllerService.deleteEngine(id),
};
